import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GlobalState } from './global-state.entity';

//This will allow us to access global (shared) variables from any component without passing in through nested controls
//Allows us to trigger dialog pop ups in application.component.ts from any component just by setting a dialog flag
@Injectable({
  providedIn: 'root',
})
export class GlobalStateService {
  private initialState: GlobalState = {};
  private stateSubject = new BehaviorSubject<GlobalState>(this.initialState);
  state$ = this.stateSubject.asObservable();

  // Get current state
  get state(): GlobalState {
    return this.stateSubject.value;
  }

  // Update one or more fields
  private updateState(newPartialState: Partial<GlobalState>) {
    this.stateSubject.next({
      ...this.stateSubject.value,
      ...newPartialState,
    });
  }

  // Reset all
  clearState() {
    this.stateSubject.next({});
  }

  getProperty(property: string) {
    const globalValue = this.state[property];
    return globalValue;
  }

  setProperty<K extends string>(key: K, value: unknown) {
    this.updateState({ [key]: value });
  }
}
